const PrimaryButton = ({ onClick, text }) => {
  return (
    <button
      className="bg-primary-1 py-s px-m bg-primary2-hover"
      onClick={onClick}
    >
      <div className="button-text">{text}</div>
    </button>
  );
};

export default PrimaryButton;
